var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHistoryBackwardOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 7.09998C12.497 7.09998 12.9 7.50292 12.9 7.99998V11.7272L15.1364 13.9636C15.4878 14.3151 15.4878 14.8849 15.1364 15.2364C14.7849 15.5878 14.2151 15.5878 13.8636 15.2364L11.3636 12.7364C11.1948 12.5676 11.1 12.3387 11.1 12.1V7.99998C11.1 7.50292 11.5029 7.09998 12 7.09998Z",
    fill: "#023F80"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0003 4.99962C17.2097 3.20901 14.7335 2.09998 12 2.09998C9.21541 2.09998 6.69792 3.25075 4.89998 5.10069V2.99998C4.89998 2.50292 4.49703 2.09998 3.99998 2.09998C3.50292 2.09998 3.09998 2.50292 3.09998 2.99998V7C3.09998 7.49706 3.50292 7.9 3.99998 7.9H7.99998C8.49703 7.9 8.89998 7.49706 8.89998 7C8.89998 6.50294 8.49703 6.1 7.99998 6.1H6.45013C7.90063 4.73494 9.85203 3.89998 12 3.89998C14.2369 3.89998 16.2607 4.80558 17.7275 6.27241C19.1944 7.73924 20.1 9.76302 20.1 12C20.1 14.2369 19.1944 16.2607 17.7275 17.7275C16.2607 19.1944 14.2369 20.1 12 20.1C10.0185 20.1 8.20518 19.3896 6.79742 18.2086C6.41663 17.8891 5.84895 17.9388 5.52949 18.3196C5.21002 18.7004 5.25974 19.2681 5.64054 19.5876C7.36035 21.0304 9.57981 21.9 12 21.9C14.7335 21.9 17.2097 20.7909 19.0003 19.0003C20.7909 17.2097 21.9 14.7335 21.9 12C21.9 9.26647 20.7909 6.79022 19.0003 4.99962Z",
    fill: "#023F80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistoryBackwardOutline);
export default __webpack_public_path__ + "static/media/history_backward_outline.fc28717b9239b8fa316b61a2fa4bd253.svg";
export { ForwardRef as ReactComponent };